














































import { PartnerPractice } from '@/shared/partner-practice';
import { DateTime } from 'luxon';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const partnerPracticesModule = namespace('partnerPractices');

@Component
export default class TargetTrackerFilters extends Vue {
    @partnerPracticesModule.Getter('partnerPracticesForCurrentUser') private partnerPractices!: Array<PartnerPractice>;

    private partnerPracticeFilter: string | null = null;
    private yearFilter: number = DateTime.local().year;
    private monthFilter: number = DateTime.local().month;

    private get partnerPracticeOptions(): Array<{}> {
        const simpsons = this.partnerPractices
            .filter((partnerPractice) => partnerPractice.isSimpsonsSolicitors)
            .map((partnerPractice) => {
                return {
                    value: partnerPractice.id!,
                    text: partnerPractice.name,
                };
            })
            .sort((a, b) => {
                if (a.text! > b.text!) { return 1; }
                if (a.text! < b.text!) { return -1; }
                return 0;
            });

        const partners = this.partnerPractices
            .filter((partnerPractice) => !partnerPractice.isSimpsonsSolicitors)
            .map((partnerPractice) => {
                return {
                    value: partnerPractice.id!,
                    text: partnerPractice.name,
                };
            })
            .sort((a, b) => {
                if (a.text! > b.text!) { return 1; }
                if (a.text! < b.text!) { return -1; }
                return 0;
            });

        return [
            { value: null, text: '--- Please Select ---' },
            { label: 'Simpsons Solicitors', options: simpsons },
            { label: 'Partner Practices', options: partners },
        ];
    }

    private get years(): Array<number> {
        const minimumYear: number = 2019;
        const maximumYear: number = DateTime.local().year + 1;

        const values: Array<number> = [];

        for (let i = minimumYear; i <= maximumYear; i++) {
            values.push(i);
        }

        return values;
    }

    private get months(): Array<{ id: number, label: string }> {
        return [
            { id: 1, label: 'January' },
            { id: 2, label: 'February' },
            { id: 3, label: 'March' },
            { id: 4, label: 'April' },
            { id: 5, label: 'May' },
            { id: 6, label: 'June' },
            { id: 7, label: 'July' },
            { id: 8, label: 'August' },
            { id: 9, label: 'September' },
            { id: 10, label: 'October' },
            { id: 11, label: 'November' },
            { id: 12, label: 'December' },
        ];
    }

    private async onFilterAsync(): Promise<void> {
        if (!await this.$validator.validateAll()) { return; }

        this.$emit('filter', {
            partnerPracticeId: this.partnerPractices.length === 1 ? this.partnerPractices[0].id! : this.partnerPracticeFilter,
            year: this.yearFilter,
            month: this.monthFilter,
        });
    }

    private onClearFilters(): void {
        this.partnerPracticeFilter = null;
        this.yearFilter = DateTime.local().year;
        this.monthFilter = DateTime.local().month;
    }
}
